import { Component, Inject, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatList, MatListItem } from '@angular/material/list';
import { AddCategory } from '../../../helpers/addSection.constants';
import { BillingModel } from '../../../model/billing/billing.model';
import { AuthService } from '../../../services/auth.service';
import { BillingService } from '../../../services/billing.service';
import { FirmService } from '../../../services/firm.service';
import { SharedModule } from '../../shared/shared.module';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddLetterModel, DialogInputModel, FirmModel, TemplateDialogModel, UserDetailModel, UserTimeZoneModel } from 'countable@model';
import { DIALOG_TYPES, LetterDialogTypes } from 'countable@helpers';
import { CoreModule } from 'src/app/core/core.module';

@Component({
  selector: 'app-countable-dialog',
  standalone: true,
  imports: [CommonModule, SharedModule, ReactiveFormsModule, CoreModule,MatList, MatListItem],
  templateUrl: './countable-dialog.component.html',
  styleUrl: './countable-dialog.component.scss'
})
export class CountableDialogComponent implements OnInit {

  public dialogType: WritableSignal<LetterDialogTypes> = signal<LetterDialogTypes>(null);
  public userDetail: Signal<UserDetailModel> = toSignal(this.auth.subjectUserDetail);
  public firm: Signal<FirmModel> = toSignal(this.firmService.subject);
  public billing: Signal<BillingModel> = toSignal(this.billingService.subject);
  public timeZone: WritableSignal<UserTimeZoneModel> = signal<UserTimeZoneModel>(null);
  public hasPegPact: WritableSignal<boolean> = signal<boolean>(false);
  public searchCtrl: FormControl<string> = new FormControl<string>('');
  public masterLibrary: WritableSignal<any> = signal<any>(null);
  public firmTemplates: WritableSignal<any> = signal<any>(null);

  constructor(@Inject(MAT_DIALOG_DATA) public data: TemplateDialogModel, public dialogRef: MatDialogRef<CountableDialogComponent,Partial<TemplateDialogModel>>,
              private auth: AuthService,private firmService: FirmService,private billingService: BillingService) {

    this.dialogType.set(this.data.dialogType);
    this.timeZone.set(this.data?.timeZoneData);
    this.masterLibrary.set(this.data?.masterLibrary);
    this.firmTemplates.set(this.data?.firmTemplates);
    this.hasPegPact.set(this.data?.isPegPactExpired);
  }

  ngOnInit(): void {
    this.searchCtrl.valueChanges.pipe().subscribe((searchText ) => {

    })
  }

  onChangeTabSections(event: any) {
    this.searchCtrl.reset();
  }

  addTemplate(templateData: any, from: 'master' | 'firm') {
    from === "master" && this.dialogRef.close({selectedMasterLetter: templateData});
    from === "firm" && this.dialogRef.close({selectedFirmLetter: templateData});
  }

}
